
























































































































interface WindowInterface extends Window {
  chrome: [null, object]
}
import Vue from 'vue'
import axios from 'axios'


/* Dev */
// const baseUrl = 'http://localhost:9090/'
// const baseUrl = 'https://dev.pitaco.in/'
// const backToAppUrl = 'https://keyakizakadev.page.link/CDvA'
// const gotoCoinHistoryUrl = 'https://keyakizakadev.page.link/UW58'

// 動画をみるボタンからアプリに遷移するリンク
// 'https://keyakizakadev.page.link/?link=https://pitaco.in/watch_video&isi=1299380545&ibi=jp.co.popshoot.Keyakizaka.dev&apn=com.popshoot.keyakizaka_android.debug'

/* Stg */
// const baseUrl = 'https://stg.pitaco.in/'
// const backToAppUrl = 'https://keyakizakainhouse.page.link/KfNz'
// const gotoCoinHistoryUrl = 'https://keyakizakainhouse.page.link/CPo8'

// 動画をみるボタンからアプリに遷移するリンク
// 'https://keyakizakainhouse.page.link/?link=https://pitaco.in/watch_video&isi=1299380545&ibi=jp.co.popshoot.Keyakizaka.inhouse&apn=com.popshoot.keyakizaka_android.staging'

/* Prd */
const baseUrl = 'https://api.pitaco.in/'
const backToAppUrl = 'https://pitacoin.page.link/G7iG'
const gotoCoinHistoryUrl = 'https://pitacoin.page.link/Tkdx'

// 動画をみるボタンからアプリに遷移するリンク
// 'https://keyakizaka.page.link/?link=https://pitaco.in/watch_video&isi=1299380545&ibi=jp.co.popshoot.Keyakizaka&apn=com.popshoot.keyakizaka_android'

export default Vue.extend({
  name: 'Main',
  data: () => {
    return {
      token: '',
      ticket: 0,
      coinHistories: [],
      coin: '0.00000 BTC',
      step: 1,
      currentType: 'clatter_darts',
      gachaFlag: false,
      backToAppUrl,
      gotoCoinHistoryUrl,
      tweetTag: 'ぴたコイン,ぴたっとダーツ',
      tweetUrl: 'https://pitacoin.page.link/Mcyr',
      tweet: 'ガチャで10 satoshiを獲得しました！',
    }
  },
  methods: {
    doGacha(type: string) {
      if (this.gachaFlag || this.step === 2) { return }
      if (this.token === '') {
        alert('トークンが正しくありません')
      } else if (this.ticket < 1000) {
        alert('チケットが足りません。アプリに戻って、チケットを獲得してください')
      } else {
        this.currentType = type
        this.gachaFlag = true
        const ua = navigator.userAgent
        const chromeFlag = (window as WindowInterface).chrome
        const scrollTag = (( !chromeFlag && 'WebkitAppearance' in document.documentElement.style )
          || ( ua.indexOf('OPR') !== -1 || ua.indexOf('Edge') !== -1 )) ? 'body' : 'html'
        document.getElementsByTagName(scrollTag)[0].scrollTop = 0
        axios({
          method: 'post',
          url: `${baseUrl}api/me/clatter`,
          headers: {
            'Authorization': `Bearer ${this.token}`,
            'Content-Type': 'application/json',
            'version': '1.0.0',
            'os': 'web',
          },
          data: {
            clatter_type: type,
          },
        }).then((resp) => {
          this.step = 2
          this.gachaFlag = false
          const iframe: HTMLIFrameElement = document.getElementById('animate') as HTMLIFrameElement
          if (iframe) {
            if (type === 'clatter_darts') {
              this.tweetTag = 'ぴたコイン,ぴたっとダーツ'
              if (resp.data.reward === 10) {
                iframe.src = '/result/gacha_dart_1.html'
                this.tweet = 'ガチャで 10 satoshiを獲得しました！'
                this.tweetUrl = 'https://pitacoin.page.link/Mcyr'
              } else {
                iframe.src = '/result/gacha_dart_2.html'
                this.tweet = 'ガチャで 555 satoshiを獲得しました！'
                this.tweetUrl = 'https://pitacoin.page.link/aGhm'
              }
            } else if (type === 'clatter_mining') {
              this.tweetTag = 'ぴたコイン,ラッキーマイニング'
              if (resp.data.reward === 10) {
                iframe.src = '/result/gacha_mining_1.html'
                this.tweet = 'ガチャで 100 satoshiを獲得しました！'
                this.tweetUrl = 'https://pitacoin.page.link/rn1N'
              } else if (resp.data.reward === 50) {
                iframe.src = '/result/gacha_mining_2.html'
                this.tweet = 'ガチャで 500 satoshiを獲得しました！'
                this.tweetUrl = 'https://pitacoin.page.link/FJQ4'
              } else if (resp.data.reward === 500) {
                iframe.src = '/result/gacha_mining_3.html'
                this.tweet = 'ガチャで 800 satoshiを獲得しました！'
                this.tweetUrl = 'https://pitacoin.page.link/DPLW'
              } else {
                iframe.src = '/result/gacha_mining_4.html'
                this.tweet = 'ガチャで 1000 satoshiを獲得しました！'
                this.tweetUrl = 'https://pitacoin.page.link/865C'
              }
            } else if (type === 'clatter_takarajima') {
              this.tweetTag = 'ぴたコイン,ぴたっと宝島'
              if (resp.data.reward === 10) {
                iframe.src = '/result/takarajima_miss.html'
                this.tweet = 'ガチャで 10 satoshiを獲得しました！'
                this.tweetUrl = 'https://pitacoin.page.link/rn1N'
              } else if (resp.data.reward === 100) {
                iframe.src = '/result/takarajima_hit_small.html'
                this.tweet = 'ガチャで 100 satoshiを獲得しました！'
                this.tweetUrl = 'https://pitacoin.page.link/FJQ4'
              } else if (resp.data.reward === 1000) {
                iframe.src = '/result/takarajima_hit_middle.html'
                this.tweet = 'ガチャで 1000 satoshiを獲得しました！'
                this.tweetUrl = 'https://pitacoin.page.link/DPLW'
              } else {
                iframe.src = '/result/takarajima_hit_big.html'
                this.tweet = 'ガチャで 10000 satoshiを獲得しました！'
                this.tweetUrl = 'https://pitacoin.page.link/865C'
              }
            }
          }
          this.getTicket()
          this.getCoinHistory()
          this.getCoin()
          setTimeout(() => {
            this.step = 3
          }, 5000)
        }).catch((err) => {
          this.gachaFlag = false
          console.error(err)
        })
      }
    },
    getParameterByName(name: string, url: string) {
      if (!url) {
        url = window.location.href
      }
      name = name.replace(/[\[\]]/g, '\\$&')
      const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
      const results = regex.exec(url)
      if (!results) {
        return null
      }
      if (!results[2]) {
        return ''
      }
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    },
    getTicket() {
      axios({
        method: 'get',
        url: `${baseUrl}api/me/ticket`,
        headers: {
          'Authorization': `Bearer ${this.token}`,
          'Content-Type': 'application/json',
          'version': '1.0.0',
          'os': 'web',
        },
      }).then((resp) => {
        this.ticket = resp.data.amount
      }).catch((err) => {
        console.error(err)
        alert('エラー。再度アプリから開いてください。')
      })
    },
    getCoinHistory() {
      axios({
        method: 'get',
        url: `${baseUrl}api/me/coin/history`,
        headers: {
          'Authorization': `Bearer ${this.token}`,
          'Content-Type': 'application/json',
          'version': '1.0.0',
          'os': 'web',
        },
      }).then((resp) => {
        this.coinHistories = resp.data
      }).catch((err) => {
        console.error(err)
      })
    },
    gotoTop() {
      this.step = 1
    },
    getCoin() {
      axios({
        method: 'get',
        url: `${baseUrl}api/me/coin`,
        headers: {
          'Authorization': `Bearer ${this.token}`,
          'Content-Type': 'application/json',
          'version': '1.0.0',
          'os': 'web',
        },
      }).then((resp) => {
        this.coin = resp.data.amount
      }).catch((err) => {
        console.error(err)
      })
    },
  },
  mounted() {
    const urlParams = this.getParameterByName('token', window.location.toString())
    this.token = urlParams || ''
    this.getTicket()
    this.getCoinHistory()
    this.getCoin()
  },
})
